import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { customizationsPropTypes } from '../../utils/prop-types';
import { isCustomized } from '../../utils/customization';
import { Container, Wrapper, Text, TextOrderId, Icon, Label, LogoLink } from './styles';

export default class Footer extends PureComponent {
  static defaultProps = {
    orderId: '',
    customizations: {},
  };

  static propTypes = {
    orderId: PropTypes.string,
    customizations: customizationsPropTypes,
  };

  render() {
    const { orderId, customizations } = this.props;
    const orderReference = orderId.split('-')[1];
    const isCustomizedPartner = isCustomized(customizations);

    return (
      <Container isCustomized={isCustomizedPartner}>
        {orderId && (
          <TextOrderId isCustomized={isCustomizedPartner}>
            <Label>Order Id</Label>: {orderReference}
          </TextOrderId>
        )}
        <Wrapper>
          <span>
            <Text>Powered by</Text>
            <LogoLink href="https://quiqup.com" target="_blank" rel="noopener noreferrer">
              <Icon icon="logo-v2-ghost" width={50} height={16} />
            </LogoLink>
          </span>
        </Wrapper>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/footer/Footer.js